<template>

    <div class="bg-gray-50">
      <div class="relative overflow-hidden">

        <div class="relative pt-6 pb-16 sm:pb-24">
            <!-- Header section -->
            <div class="max-w-7xl mx-auto py-16 px-4 sm:py-24 sm:px-6 lg:px-8">

              <div class="container">
                <v-alert type="info">
                  <!-- @todo Make these massages associated with the images -->
                  <h3 style="text-align:center; text-decoration:underline">Simplify your digital tools by placing them under one roof</h3>
                  <p id="top">Do all the programs for businesses overwhelm you? One system for invoicing,
                    one system for your website, emails, apps, calendars, collaboration tools...<br><br>
                    Well you're not alone! That's why we develop software tailored to you.
                    Your software should be an extension of you, at VQV we make it happen.
                  </p>
                </v-alert>
              </div>
    

            </div>

        </div>


      </div>

    </div>



</template>

<script>
  export default {
    data () {
      return {
        items: [
          {
            src: 'https://cdn.vuetifyjs.com/images/carousel/squirrel.jpg',
          },
          {
            src: 'https://cdn.vuetifyjs.com/images/carousel/sky.jpg',
          },
          {
            src: 'https://cdn.vuetifyjs.com/images/carousel/bird.jpg',
          },
          {
            src: 'https://cdn.vuetifyjs.com/images/carousel/planet.jpg',
          },
        ],
      }
    },
  }
</script>
<style>

#top{
  margin-top: 2em;
}

</style>
